var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "general-container" }, [
    _c("div", { staticClass: "tabs" }, [
      _c(
        "div",
        { staticClass: "tabs-left" },
        _vm._l(_vm.tabs, function (v) {
          return _c(
            "div",
            {
              key: v.key,
              class: [
                "tab-item",
                v.key === _vm.activeTab ? "tab-item-active" : "",
              ],
              on: {
                click: function ($event) {
                  return _vm.switchTab(v)
                },
              },
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: v.key === _vm.activeTab,
                    expression: "v.key === activeTab",
                  },
                ],
                staticClass: "activebar",
              }),
              _vm._v("\n                " + _vm._s(v.label) + "\n            "),
            ]
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "tabs-right" },
        [
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { loading: _vm.loading },
              on: { click: _vm.save },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "general-body" },
      [
        _vm.activeTab === 0
          ? _c("GeneralSetting", {
              ref: "tab_0",
              on: { onConfChange: _vm.onConfChange },
            })
          : _vm._e(),
        _vm.activeTab === 1
          ? _c("ClientOrganizationStructure", {
              ref: "tab_1",
              on: { onConfChange: _vm.onConfChange },
            })
          : _vm._e(),
        _vm.activeTab === 2
          ? _c("TileConfiguration", {
              ref: "tab_2",
              on: { onConfChange: _vm.onConfChange },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }